<template>
    <div>
        <v-text-field
            ref="option"
            v-model="value"
            :name="name"
            :label="label"
            clearable
            :single-line="singleLine"
            variant="outlined"
            density="comfortable"
            hide-details
            theme="dark"
        />
    </div>
</template>

<script lang="ts">
    import {Component, Prop, Vue} from 'vue-facing-decorator'

    @Component
    export class TextOption extends Vue {
        @Prop({default: false}) outlined
        @Prop({default: true}) singleLine
        value = null

        @Prop({
            required: true,
        })
        name

        @Prop()
        label

        created() {
            this.value = this.$route.query[this.name]
        }
    }

    export default TextOption
</script>
